import parsePath from "parse-filepath";
import { Extension } from "ts/api/attachmentFile";

export const prettifyFileExtension = <T extends { name: string } = File>(
  file: T
) => {
  return parsePath(file.name).ext.replace(".", "").toLowerCase() as Extension;
};
